import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatTabsModule} from '@angular/material/tabs';
import {MatMenuModule} from '@angular/material/menu';
import {MatBadgeModule} from '@angular/material/badge';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SpinnerComponent } from './utility/spinner/spinner.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { SpyDirective } from './directives/spy.directive';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

import { NgbModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslationPipe } from './pipes/translation.pipe';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastComponent } from './utility/toasts/toast/toast.component';
import { InterceptorInterceptor } from './services/interceptor.interceptor';
import { CustomNgxSpinnerComponent } from './utility/spinner/ngx-spinner/custom-ngx-spinner.component';
import { NgxSpinnerModule } from 'ngx-spinner';

@NgModule({
  declarations: [
    AppComponent,
    SpyDirective,
    ToastComponent,
    CustomNgxSpinnerComponent,

  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatToolbarModule, MatButtonModule, MatIconModule, MatProgressSpinnerModule, 
    MatBadgeModule, MatMenuModule, MatTabsModule, MatInputModule, MatFormFieldModule, 
    SpinnerComponent,
    HttpClientModule,
    NgbModule,
    TranslationPipe,
    FormsModule, ReactiveFormsModule,
    NgxSpinnerModule, NgbDropdownModule
  ],
  exports:[SpinnerComponent,TranslationPipe,NgbModule,FormsModule, ReactiveFormsModule, NgxSpinnerModule ],
  providers: [    {
    provide: HTTP_INTERCEPTORS,
    useClass: InterceptorInterceptor,
    multi: true,
  },
  TranslationPipe],
  bootstrap: [AppComponent]
})
export class AppModule { }
